// extracted by mini-css-extract-plugin
module.exports = {"seatInfo":"SeatInfo_seatInfo__2gN-b","section":"SeatInfo_section__2HDGh","row":"SeatInfo_row__1baJS","quantity":"SeatInfo_quantity__3IQp_"};